import React, { useRef } from 'react'
import NewButton from '../Button/NewButton'
import SearchInput from '../ui/Searchinput'
import { TiPlus } from 'react-icons/ti'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { FaCalendarAlt } from 'react-icons/fa'

const Table = ({
  tableHeadings = [],
  showSearch = true,
  data,
  searchTerm,
  setSearchTerm,
  showDatePicker,
  onAdd,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  showExtraAdd = true,
  actionAdd,
  placeholder = 'Search Here...'
}) => {
  const datePickerRefFrom = useRef(null);
  const datePickerRefTo = useRef(null);

  const handleIconClickFrom = () => {
    datePickerRefFrom.current.setOpen(true);
  };

  const handleIconClickTo = () => {
    datePickerRefTo.current.setOpen(true);
  };
  return (
    <section className='w-full overflow-hidden overflow-x-auto overflow-y-auto text-black'>
      <div className='items-center justify-between gap-6  space-y-4 lg:flex lg:space-y-0'>
        <div>
          {showSearch && (
            <SearchInput
              placeholder={placeholder}
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
          )}
        </div>
        {showDatePicker && (
          <div className='md:flex md:space-y-0 space-y-4 items-center gap-3'>
            <div className=''>
              <DatePicker
                selected={fromDate}
                onChange={date => setFromDate(date)}
                maxDate={toDate || new Date()}
                isClearable
                ref={datePickerRefFrom}
                showIcon
                icon={
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2" onClick={handleIconClickFrom}>
                    <FaCalendarAlt className="text-gray-400 hover:text-gray-600" />
                  </div>
                }
                placeholderText='From Date'
                className='w-full px-3 py-2.5 border rounded-md bg-white text-sm outline-none'
              />
            </div>

            <div className=''>
              <DatePicker
                selected={toDate}
                onChange={date => setToDate(date)}
                minDate={fromDate}
                maxDate={new Date()}
                isClearable
                ref={datePickerRefTo}
                showIcon
                icon={
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2" onClick={handleIconClickTo}>
                    <FaCalendarAlt className="text-gray-400 hover:text-gray-600" />
                  </div>
                }
                placeholderText='To Date'
                className='w-full px-3 py-2.5 border rounded-md bg-white text-sm outline-none'
              />
            </div>
          </div>
        )}
        {showExtraAdd && (
          <div className='w-full ml-auto   lg:w-24'>
            <NewButton onClick={onAdd}>
              <TiPlus />

              {actionAdd || 'Add'}
            </NewButton>
          </div>
        )}
      </div>

      <div className='w-full mt-6 overflow-hidden overflow-y-auto'>
        <div className='overflow-x-auto'>
          <div className='hidden xl:block'>
            <table className='w-full bg-white border-collapse'>
              <thead className='bg-gray-200 text-gray-700 capitalize'>
                <tr>
                  {tableHeadings.map((heading, index) => (
                    <th
                      key={index}
                      className='px-5 py-4 text-base text-left font-[700] text-black whitespace-nowrap'
                    >
                      {heading}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data && Array.isArray(data) && data.length > 0 ? (
                  data.map((row, index) => {
                    const rowClass = index % 2 === 0 ? 'bg-white' : 'bg-white'
                    return (
                      <tr
                        key={index}
                        className={`${rowClass} border-b border-black/10 capitalize`}
                      >
                        {row.map((cell, cellIndex) => (
                          <td
                            key={cellIndex}
                            className='px-5 py-3 text-sm font-normal text-black w-fit'
                          >
                            {cell}
                          </td>
                        ))}
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={tableHeadings.length}
                      className='px-4 py-3 text-center text-black'
                    >
                      <div className='p-4 text-center rounded-lg shadow-lg'>
                        <img
                          src='/assets/data-not-found.webp'
                          alt=''
                          className='w-[180px] mx-auto'
                        />
                        <p className='text-xl font-bold text-black capitalize'>
                          No data found
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile Card View */}
          <div className='block xl:hidden space-y-4'>
            {data && Array.isArray(data) && data.length > 0 ? (
              data.map((row, index) => (
                <div
                  key={index}
                  className='divide-y divide-black/20  rounded-lg shadow-lg bg-white'
                >
                  {row.map((cell, cellIndex) => (
                    <div
                      key={cellIndex}
                      className='lg:flex w-full lg:space-y-0 space-y-2 px-4 py-2 justify-between'
                    >
                      <div className='w-full'>
                        <p className='text-base font-medium text-[#161515]'>
                          {tableHeadings[cellIndex]}
                        </p>
                      </div>
                      <div className='w-full'>
                        <p className='text-sm font-medium text-black'>{cell}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <div className='p-4 text-center rounded-lg shadow-lg'>
                <img
                  src='/assets/data-not-found.webp'
                  alt=''
                  className='w-[180px] mx-auto'
                />
                <p className='text-xl font-bold text-black capitalize'>
                  No data found
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Table
